module.exports = __webpack_public_path__ + "img/icon_invasion_disabled.svg";